/* ---------------------------------------------------------------------------
   pm-bundle-picker.js — 2026-09-25

   Selecteur d'offre de la fiche produit v2 (template rolling-pin-v2) :
   un palier = N emplacements, chaque emplacement = un design + une taille.

   Source des vignettes : /collections/<handle>[/<tag>]?view=pm-pins
   (templates/collection.pm-pins.liquid). Liquid ne peut pas les rendre : il
   plafonne all_products a 20 produits et collection.products a 50 par boucle,
   or la collection en compte 185, triee MANUAL.

   Remises : ce sont des CODES, pas des remises automatiques. Apres l'ajout au
   panier le script applique le code du palier via /discount/<CODE>, qui le
   rattache a la session et le porte jusqu'a la caisse. Un palier dont le code
   est vide n'affiche aucun prix barre : on n'annonce pas une remise que la
   caisse n'appliquera pas.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.querySelector('[data-pmb]');
  var cfgEl = document.querySelector('[data-pmb-config]');
  if (!root || !cfgEl) return;

  var CFG = JSON.parse(cfgEl.textContent);
  var cache = {};            // clef de chips -> tableau de produits
  // La taille vaut pour TOUT le lot : on ne veut pas d'un panier ou le 1er est Regular
  // et le 2e Big. Elle vit donc dans l'etat global, pas dans chaque emplacement.
  // `memo` garde chaque emplacement deja rempli, tous paliers confondus (2026-09-29) : passer par
  // « Buy 1 » (1 emplacement) puis revenir a « Choose Any 3 » rend Pin 2 et Pin 3 tels quels.
  var state = { tier: 0, slots: [], open: 0, size: 'reg', memo: [] };

  // Variante d'un produit pour la taille choisie, avec repli sur Regular : tous les
  // designs n'ont pas de Big, et les cubes n'ont qu'une variante.
  function variantFor(p) {
    if (!p) return null;
    var want = state.size === 'big' ? p.big : p.reg;
    if (want && want.a) return want;
    return p.reg && p.reg.a ? p.reg : null;
  }

  // Un palier est remise s'il est couvert par une remise automatique (auto) ou
  // par un code a appliquer. Sans l'un ni l'autre on n'affiche aucun prix barre.
  function hasDiscount(t) { return !!(t.auto || t.code); }

  // "Select Free Pin" / "Select Free Cube" : le mot suit le produit de l'emplacement,
  // et a defaut celui de la page.
  function kindWord() { return CFG.unitWord === 'cube' ? 'Cube' : 'Pin'; }

  // Libelle pose sur la photo de l'emplacement. Il dit a la cliente CE QU'ELLE CHOISIT ici :
  // son 1er rouleau, son 2e, ou celui qui est offert. Sans lui, deux cartes identiques se
  // suivaient et rien ne disait laquelle etait la gratuite.
  function slotLabel(n, t) {
    // 2026-09-28 : « Select » -> « Choose » (Imran), meme verbe que le titre « Choose Any 3 Designs ».
    if (isFreeSlot(n, t)) return 'Choose Free ' + kindWord();
    return 'Choose ' + kindWord() + ' ' + (n + 1);
  }

  // Un emplacement est "offert" quand il tombe dans les N derniers du palier.
  function isFreeSlot(n, t) { return hasDiscount(t) && n >= (t.slots - t.free); }

  /* ---------- utilitaires ------------------------------------------------ */

  // Le format de la boutique est "${{amount_no_decimals}}" : il ARRONDIT. Un prix a
  // l'unite comme 17,50 $ y devenait 18 $. On ne supprime donc les decimales que
  // lorsque le montant est rond ; sinon on en affiche deux. Les totaux gardent
  // l'allure du reste du site ($35 et non $35.00).
  function money(cents) {
    var f = CFG.moneyFormat || '${{amount}}';
    var neg = cents < 0;
    var n = Math.abs(cents) / 100;
    var whole = Math.abs(cents) % 100 === 0;

    function parts(dot, comma, decimals) {
      var fixed = n.toFixed(decimals);
      var bits = fixed.split('.');
      bits[0] = bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma);
      return bits.length > 1 ? bits[0] + dot + bits[1] : bits[0];
    }

    var out;
    if (f.indexOf('{{amount_no_decimals_with_comma_separator}}') > -1) {
      out = f.replace('{{amount_no_decimals_with_comma_separator}}', parts(',', '.', whole ? 0 : 2));
    } else if (f.indexOf('{{amount_with_comma_separator}}') > -1) {
      out = f.replace('{{amount_with_comma_separator}}', parts(',', '.', whole ? 0 : 2));
    } else if (f.indexOf('{{amount_no_decimals}}') > -1) {
      out = f.replace('{{amount_no_decimals}}', parts('.', ',', whole ? 0 : 2));
    } else if (f.indexOf('{{amount}}') > -1) {
      // 2026-09-28 : « .00 » retire aussi ici quand le montant est rond (690 dh, pas 690.00 dh),
      // pour que la colonne prix du palier laisse le titre sur une ligne.
      out = f.replace('{{amount}}', parts('.', ',', whole ? 0 : 2));
    } else {
      out = '$' + parts('.', ',', 2);
    }
    return (neg ? '-' : '') + out + ((window.Shopify && Shopify.currency && /^(CAD|AUD)$/.test(Shopify.currency.active)) ? '\u00a0' + Shopify.currency.active : ''); // 2026-10-09 : $42 CAD / AUD
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* ---------- chargement des designs ------------------------------------- */

  // "Best sellers" = les 25 handles de CFG.best, dans cet ordre. Ils sont disperses
  // dans les 185 produits, d'ou le balayage de toutes les pages (4 x 50) en parallele.
  function loadBest() {
    if (cache.best) return Promise.resolve(cache.best);
    // Nombre de pages a balayer : 4 pour les 185 rouleaux, 1 pour les 40 cubes.
    var list = [], k;
    for (k = 1; k <= (CFG.pages || 4); k++) list.push(k);
    var pages = list.map(function (n) {
      return fetchJSON('/collections/' + CFG.collection + '?view=pm-pins&page=' + n)
        .catch(function () { return { items: [] }; });
    });
    return Promise.all(pages).then(function (res) {
      var by = {};
      res.forEach(function (r) { (r.items || []).forEach(function (p) { by[p.h] = p; }); });
      cache.best = CFG.best.map(function (h) { return by[h]; }).filter(Boolean);
      // Le produit de la page passe en tete s'il n'est pas dans les 25 : sinon la vignette
      // selectionnee n'apparaissait nulle part dans la grille.
      if (!cache.best.some(function (p) { return p.h === CFG.currentProduct.h; })) {
        cache.best.unshift(by[CFG.currentProduct.h] || CFG.currentProduct);
      }
      return cache.best;
    });
  }

  function loadTag(tag) {
    if (cache[tag]) return Promise.resolve(cache[tag]);
    return fetchJSON('/collections/' + CFG.collection + '/' + tag + '?view=pm-pins')
      .then(function (r) { cache[tag] = r.items || []; return cache[tag]; })
      .catch(function () { cache[tag] = []; return cache[tag]; });
  }

  function load(chip) {
    return chip && chip.tag ? loadTag(chip.tag) : loadBest();
  }

  /* ---------- etat ------------------------------------------------------- */

  // Tous les emplacements demarrent sur le produit de la page, y compris les gratuits :
  // un emplacement vide laissait le prix du palier a "—" et le bouton desactive alors
  // que la cliente n'avait rien demande de special.
  function blankSlots(n) {
    var out = [], i;
    // 2026-09-28 : `picked` = choisi par la cliente. Les emplacements 2+ sont pre-remplis (pour
    // que le prix et le bouton marchent) mais affiches comme « Choose one below », sans vignette
    // entouree, tant qu'elle n'a pas clique sur un design (Imran).
    for (i = 0; i < n; i++) out.push({ product: CFG.currentProduct, chip: CFG.chips[0], expanded: false, picked: i === 0 });
    return out;
  }

  function setTier(i) {
    // On range d'abord les emplacements du palier qu'on quitte dans la memoire, puis on remplit
    // le nouveau palier depuis cette memoire. Avant, seuls les emplacements du palier quitte
    // etaient repris : « Buy 1 » n'en a qu'un, donc Pin 2 et Pin 3 etaient perdus au retour.
    state.slots.forEach(function (s, n) { state.memo[n] = s; });
    state.tier = i;
    state.slots = blankSlots(CFG.tiers[i].slots);
    state.memo.forEach(function (s, n) { if (s && n < state.slots.length) state.slots[n] = s; });
    // Le 1er emplacement est celui qui est ouvert. La regle "ouvrir le 2e" ne valait que
    // pour Buy 1 Get 1, ou les deux cartes sont desormais ouvertes de toute facon ; sur
    // Buy 2 Get 3 elle faisait commencer la cliente au milieu de son lot.
    state.open = 0;
    render();
  }

  // Prix : la remise BxGy libere les N articles les MOINS chers du lot.
  // Les emplacements pas encore choisis sont chiffres au prix de reference (la variante
  // Regular du produit de la page), pour que le palier affiche un prix des l'ouverture.
  function math(tierIndex) {
    var t = CFG.tiers[tierIndex];
    var live = tierIndex === state.tier;
    var arr = [], filled = 0, i;
    // 2026-09-30 : la taille se choisit au-dessus des offres, pour tout le lot — le palier NON
    // choisi doit donc etre chiffre dans cette taille aussi (il restait au prix Regular quand
    // « Big » etait choisi). Reference = le produit de la page dans la taille choisie.
    var baseV = CFG.currentProduct ? variantFor(CFG.currentProduct) : null;
    var base = baseV ? baseV.p : CFG.basePrice;
    for (i = 0; i < t.slots; i++) {
      var s = live ? state.slots[i] : null;
      var v = s && s.product ? variantFor(s.product) : null;
      if (v) { arr.push(v.p); filled++; } else { arr.push(base); }
    }
    var full = arr.reduce(function (a, b) { return a + b; }, 0);
    var pay = full;
    if (hasDiscount(t)) {
      var sorted = arr.slice().sort(function (a, b) { return a - b; });
      pay = full - sorted.slice(0, t.free).reduce(function (a, b) { return a + b; }, 0);
    }
    return { full: full, pay: pay, unit: pay / t.slots,
             complete: filled === t.slots, discounted: hasDiscount(t) };
  }

  function totals() { return math(state.tier); }

  /* ---------- rendu ------------------------------------------------------ */

  function render() {
    var host = root.querySelector('[data-pmb-tiers]');
    host.innerHTML = '';
    CFG.tiers.forEach(function (t, i) {
      // Le ruban reste visible meme quand le palier n'est pas choisi — c'est la qu'il sert,
      // a faire regarder plus bas. Il passe alors en version froide (contour, pas de plein)
      // pour ne pas rivaliser avec le palier reellement selectionne.
      var badged = !!t.badge;
      var wrap = el('div', 'pmb__wrap' + (badged ? ' pmb__wrap--badged' : ''));
      if (badged) {
        var tone = t.badgeTone ? ' pmb__badge--' + t.badgeTone : '';
        wrap.appendChild(el('span', 'pmb__badge' + tone + (i === state.tier ? '' : ' pmb__badge--idle'), t.badge));
      }
      var box = el('div', 'pmb__tier' + (i === state.tier ? ' is-on' : ''));

      var head = el('div', 'pmb__head');
      head.appendChild(el('div', 'pmb__radio'));
      var tt = el('div', 'pmb__tt');
      tt.appendChild(el('div', 'pmb__t1', t.title));
      var m = math(i);
      // 2026-09-28 : un palier remise peut porter son propre texte (`sub`), en vert, a la place
      // du prix unitaire calcule — ex. « Pay Only for 2 », plus clair que « $19.33 » pour 65+.
      tt.appendChild(el('div', 'pmb__t2', hasDiscount(t)
        ? (t.sub || 'Only ' + money(m.unit) + ' per ' + CFG.unitWord)
        : '<span style="color:#6B6B6B">' + (t.sub || money(m.unit) + ' per ' + CFG.unitWord) + '</span>'));
      // 2026-09-26 : ligne optionnelle sous le prix unitaire (ex. « + FREE Recipe Book »), en HTML.
      if (t.extra) tt.appendChild(el('div', 'pmb__t2', t.extra));
      // 2026-09-28 : ligne grise optionnelle (maquette d'Imran : « Same or different designs – your choice! »).
      if (t.note) tt.appendChild(el('div', 'pmb__choice', t.note));
      head.appendChild(tt);
      head.appendChild(tierPrice(t, i));
      head.addEventListener('click', function () { if (i !== state.tier) setTier(i); });
      box.appendChild(head);

      if (i === state.tier) {
        if (t.key === 'single') {
          // Pas de selecteur de design ici : la cliente prend le rouleau sur lequel elle est
          // arrivee. Afficher une carte "#1 — Mushroom / Open" lui demandait de confirmer un
          // choix qu'elle a deja fait en ouvrant la page. Seule la taille reste a decider.
          // 2026-09-30 : la taille est choisie AU-DESSUS des offres (« Select Size: »), plus ici.
        } else {
          // TOUS les emplacements restent ouverts, y compris les 5 de Buy 2 Get 3 (Imran,
          // apres avoir ete prevenu de la hauteur). La cliente voit d'un coup ce qu'elle
          // prend et ce qu'elle recoit, sans rien avoir a deplier.
          var openAll = true;
          state.slots.forEach(function (s, n) {
            box.appendChild((openAll || n === state.open) ? slotOpen(s, n, t) : slotClosed(s, n, t));
          });
          // Une SEULE rangee de tailles, sous les cartes : la taille s'applique au lot
          // entier, la repeter dans chaque carte laissait croire qu'on pouvait en choisir
          // une par rouleau.
          // 2026-09-30 : plus de rangee de tailles ici, voir renderSizeTop().
        }
      }
      wrap.appendChild(box);
      host.appendChild(wrap);
    });
    renderSizeTop();
    renderATC();
  }

  // 2026-09-30 (Imran) : « Select Size: » + Regular / Big AU-DESSUS de « Choose your savings »,
  // une seule fois pour tous les paliers (la taille vaut pour tout le lot). Rien sur les cubes.
  function renderSizeTop() {
    var boxTop = root.querySelector('[data-pmb-sizebox]');
    if (!boxTop) return;
    boxTop.innerHTML = '';
    var row = sizeRow();
    if (!row) { boxTop.style.display = 'none'; return; }
    boxTop.style.display = '';
    row.className += ' pmb__sizes--top';
    // 2026-09-30 : « Size: Regular » — le libelle affiche la taille choisie (reference d'Imran).
    // 2026-09-30 (2) : juste « Size: », sans la taille choisie derriere (Imran) — le bouton orange la montre deja.
    boxTop.appendChild(el('p', 'pmb__sizelabel', '<b>Size:</b>'));
    boxTop.appendChild(row);
  }

  function tierPrice(t, i) {
    var pr = el('div', 'pmb__pr');
    var m = math(i);
    if (m.discounted && m.pay < m.full) pr.appendChild(el('div', 'pmb__was', money(m.full)));
    pr.appendChild(el('div', 'pmb__now', money(m.pay)));
    // 2026-09-28 : pastille verte sous le prix. `priceSave` = « Save $X », X = prix barre - prix paye,
    // recalcule a chaque changement de design ou de taille ; `priceNote` = texte fixe.
    if (t.priceSave && m.full > m.pay) pr.appendChild(el('div', 'pmb__fornote', 'Save ' + money(m.full - m.pay)));
    else if (t.priceNote) pr.appendChild(el('div', 'pmb__fornote', t.priceNote));
    return pr;
  }

  function isPicked(s, n) { return n === 0 || s.picked === true; }
  function slotName(s, n) {
    return (s.product && isPicked(s, n)) ? s.product.t : '<span class="pmb__pickme">Choose one below &darr;</span>';
  }

  // 2026-09-28 (Imran) : sur l'emplacement offert, une pastille verte « FREE » entre
  // « Pin 3 » et le nom du design : « Pin 3 [FREE]: Santa Claus ».
  function slotPrefix(n, t) {
    // 2026-09-29 : pastille retiree (Imran). Passer SHOW_FREETAG a true pour la remettre.
    var SHOW_FREETAG = false;
    return kindWord() + ' ' + (n + 1) + (SHOW_FREETAG && isFreeSlot(n, t) ? '<span class="pmb__freetag">FREE</span>' : '');
  }

  function slotHeader(s, n, t, open) {
    var row = el('div', 'pmb__srow');
    var name = el('div', 'pmb__sname');
    // 2026-09-28 : « #1 — Prime » -> « Pin 1: Prime » (Imran), « Cube 1: … » sur les cubes.
    name.innerHTML = slotPrefix(n, t) + ': ' + slotName(s, n);
    row.appendChild(name);
    row.appendChild(el('button', 'pmb__toggle', open ? 'Close &and;' : 'Open &or;'));
    return row;
  }

  function slotClosed(s, n, t) {
    var box = el('div', 'pmb__closed');
    var th = el('div', 'pmb__thumb');
    if (s.product) { var im = new Image(); im.src = s.product.img; th.appendChild(im); }
    box.appendChild(th);
    var mid = el('div'); mid.style.flex = '1'; mid.style.minWidth = '0';
    mid.appendChild(el('div', 'pmb__sname',
      slotPrefix(n, t) + ': ' + slotName(s, n)));
    mid.appendChild(el('div', 'pmb__csub', state.size === 'big' ? 'Big' : 'Regular'));
    box.appendChild(mid);
    box.appendChild(el('div', 'pmb__toggle', 'Open &or;'));
    box.addEventListener('click', function () { state.open = n; render(); });
    return box;
  }

  function slotOpen(s, n, t) {
    var box = el('div', 'pmb__slot');
    var head = slotHeader(s, n, t, true);
    var tog = head.querySelector('.pmb__toggle');
    // Tout est ouvert : il n'y a plus rien a replier.
    tog.remove();
    box.appendChild(head);

    if (CFG.showChips !== false) {
    var chips = el('div', 'pmb__chips');
    var shown = CFG.chips.slice();
    // Une pastille choisie dans More Choices s'ajoute a la rangee : sans cela, le filtre
    // actif n'etait visible nulle part une fois le menu referme.
    if (s.chip && s.chip.id === 'more') shown.push(s.chip);
    shown.forEach(function (c) {
      var b = el('button', 'pmb__chip' + (c.tag === s.chip.tag ? ' is-on' : ''),
        (c.icon ? '<span class="pmb__ico" aria-hidden="true">' + c.icon + '</span>' : '') + c.label);
      b.type = 'button';
      b.addEventListener('click', function () { s.chip = c; s.expanded = false; render(); });
      chips.appendChild(b);
    });

    if (CFG.more && CFG.more.length) {
    var sel = el('select', 'pmb__more-sel');
    sel.setAttribute('aria-label', 'More filters');
    sel.appendChild(new Option('+ Show More', ''));
    CFG.more.forEach(function (m) { sel.appendChild(new Option(m.label, m.tag)); });
    sel.addEventListener('change', function () {
      if (!sel.value) return;
      var m = CFG.more.filter(function (x) { return x.tag === sel.value; })[0];
      s.chip = { id: 'more', label: m.label, tag: m.tag, icon: '' };
      s.expanded = false;
      render();
    });
    chips.appendChild(sel);
    }
    box.appendChild(chips);
    }

    var grid = el('div', 'pmb__grid');
    grid.appendChild(hero(s, n, t));
    box.appendChild(grid);

    load(s.chip).then(function (list) {
      // On verifie que CETTE grille est encore dans la page (un re-render l'aurait remplacee),
      // et non que l'emplacement est celui qui est ouvert : plusieurs peuvent l'etre.
      if (!grid.isConnected) return;
      if (!list.length) {
        var empty = el('p', 'pmb__note', 'No design in this filter yet — pick another one.');
        empty.style.gridColumn = 'span 4';
        grid.appendChild(empty);
        return;
      }
      // Grille repliee : la photo occupe 2x2 avec 4 vignettes a cote (rangees 1-2), puis
      // une rangee de 4 — soit 3 rangees de contenu, le bouton en 4e. Deplie, on montre
      // tout ce qui est charge pour le filtre en cours.
      var COLLAPSED = 12; // 2026-09-28 : 4 rangees avant « Show more » (photo 2x2 + 4, puis 2 x 4) — Imran

      // Le design choisi passe TOUJOURS en premiere vignette. Deux cas sinon :
      //  - il n'est pas dans le filtre courant (un tag qui ne le contient pas) et n'apparait
      //    nulle part, alors que la grande photo le montre ;
      //  - il est dans la liste mais au-dela des 12 visibles (Mushroom est 23e des ventes),
      //    donc la grille repliee n'affichait aucune vignette selectionnee.
      var full = list.slice();
      var limit = s.expanded ? full.length : COLLAPSED;
      // Seul le produit DE LA PAGE peut etre remonte en tete, et seulement s'il ne serait pas
      // visible autrement (absent du filtre, ou au-dela des 12 vignettes : Mushroom est 23e).
      // On ne remonte jamais le design que la cliente vient de choisir : la grille resterait
      // stable sous son doigt, elle ne doit pas se reordonner a chaque clic.
      var pin = CFG.currentProduct;
      if (pin) {
        var idx = -1, k;
        for (k = 0; k < full.length; k++) { if (full[k].h === pin.h) { idx = k; break; } }
        if (idx === -1 || idx >= limit) {
          full.unshift(idx > -1 ? full.splice(idx, 1)[0] : pin);
        }
      }
      var shown = s.expanded ? full : full.slice(0, COLLAPSED);
      shown.forEach(function (p) {
        var on = isPicked(s, n) && s.product && s.product.h === p.h;
        var b = el('button', 'pmb__sw' + (on ? ' is-on' : ''));
        b.type = 'button';
        var im = new Image(); im.loading = 'lazy'; im.src = p.img; im.alt = p.t;
        b.appendChild(im);
        b.addEventListener('click', function () {
          s.product = p; s.picked = true;
          if (n === 0) syncPageProduct(p.h);
          render();
        });
        // 2026-09-30 (Imran) : la vignette choisie porte sa propre loupe, pour voir les autres
        // photos du design sans remonter jusqu'a la grande photo de l'emplacement.
        // Bouton FRERE de la vignette dans un conteneur (un bouton ne peut pas en contenir un autre).
        if (on) {
          var wrap = el('div', 'pmb__swbox');
          wrap.appendChild(b);
          var sz = el('button', 'pmb__swzoom',
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="16" y1="16" x2="21" y2="21"/>'
            + '<line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>');
          sz.type = 'button';
          sz.setAttribute('aria-label', 'See more photos of ' + p.t);
          sz.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(p.h); });
          wrap.appendChild(sz);
          grid.appendChild(wrap);
        } else {
          grid.appendChild(b);
        }
      });
      if (!s.expanded && list.length > COLLAPSED) {
        var more = el('button', 'pmb__more', '+ Show more patterns');
        more.type = 'button';
        more.addEventListener('click', function () { s.expanded = true; render(); });
        grid.appendChild(more);
      }
    });

    return box;
  }

  // Rangee Regular / Big. Rendue dans l'emplacement, ou seule pour le palier "Buy 1".
  // Les cubes n'ont pas de tailles : l'afficher y serait faux.
  function sizeRow() {
    if (CFG.hasSizes === false) return null;
    var sizes = el('div', 'pmb__sizes');
    [['reg', 'Regular'], ['big', 'Big']].forEach(function (pair) {
      var b = el('button', 'pmb__sz' + (state.size === pair[0] ? ' is-on' : ''), pair[1]);
      b.type = 'button';
      // La taille vaut pour tout le lot : on ne la propose que si CHAQUE design choisi
      // l'a en stock, sinon un article serait silencieusement servi en Regular.
      var ok = state.slots.every(function (s) {
        if (!s.product) return true;
        var v = s.product[pair[0] === 'big' ? 'big' : 'reg'];
        return !!(v && v.a);
      });
      if (!ok) b.disabled = true;
      // Un seul choix pour tout le lot : on repeint tous les emplacements.
      b.addEventListener('click', function () { if (!b.disabled) { state.size = pair[0]; render(); } });
      sizes.appendChild(b);
    });
    return sizes;
  }

  function hero(s, n, t) {
    var h = el('div', 'pmb__hero');
    h.appendChild(el('span', 'pmb__freeimg' + (isFreeSlot(n, t) ? '' : ' pmb__freeimg--paid'), slotLabel(n, t)));
    var src = s.product ? s.product.img.replace(/width=\d+/, 'width=900') : CFG.currentImg;
    var im = new Image(); im.src = src; im.alt = s.product ? s.product.t : CFG.currentTitle;
    h.appendChild(im);
    var z = el('button', 'pmb__zoom',
      '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16" y1="16" x2="21" y2="21"/>'
      + '<line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>');
    z.type = 'button';
    z.addEventListener('click', function (e) {
      e.stopPropagation();
      openLightbox(s.product ? s.product.h : CFG.current);
    });
    h.appendChild(z);
    return h;
  }

  /* ---------- titre et photos du haut de page ----------------------------- */

  // Le design choisi dans l'emplacement 1 se voit en haut de la fiche : titre + galerie.
  // Purement visuel — l'URL, les avis, les onglets et le JSON-LD restent ceux du produit
  // de la page. On remplace les SOURCES des images deja en place plutot que de reconstruire
  // la galerie : le carrousel du theme (slick) garde ses slides et son etat.
  var pageCache = {};
  function syncPageProduct(handle) {
    if (CFG.syncPage === false || !handle) return;
    var apply = function (p) {
      var h1 = document.querySelector('h1.product-single__title');
      if (h1) h1.textContent = p.title;
      var imgs = p.images || [];
      if (!imgs.length) return;
      // /products/<handle>.js renvoie les URL en pleine resolution ; on redemande la
      // largeur servie a l'origine, sinon la fiche telechargeait des images de 2000px
      // pour une vignette de 180.
      var sized = function (src, w) {
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      };
      var swap = function (nodes, w) {
        for (var i = 0; i < nodes.length; i++) {
          var src = imgs[i % imgs.length];
          if (!src) continue;
          nodes[i].removeAttribute('srcset');
          nodes[i].removeAttribute('data-srcset');
          nodes[i].src = sized(src, w);
        }
      };
      swap(document.querySelectorAll('img.product-single__media, img.product--image'), 900);
      swap(document.querySelectorAll('[data-product-thumbnails] img, .product-single__thumbnail img, .product__thumb img'), 200);
    };
    if (pageCache[handle]) { apply(pageCache[handle]); return; }
    fetchJSON('/products/' + handle + '.js').then(function (p) { pageCache[handle] = p; apply(p); })
      .catch(function () {});
  }

  /* ---------- visionneuse ------------------------------------------------ */

  function openLightbox(handle) {
    fetchJSON('/products/' + handle + '.js').then(function (p) {
      var imgs = (p.images || []).map(function (u) { return u.indexOf('//') === 0 ? u : u; });
      if (!imgs.length) return;
      var ov = el('div', 'pmb-lb');
      var box = el('div', 'pmb-lb__box');
      var close = el('button', 'pmb-lb__close', '&times;'); close.type = 'button';
      var main = new Image(); main.className = 'pmb-lb__main'; main.src = imgs[0];
      var strip = el('div', 'pmb-lb__strip');
      imgs.forEach(function (u, i) {
        var th = new Image(); th.src = u; if (i === 0) th.className = 'is-on';
        th.addEventListener('click', function () {
          main.src = u;
          strip.querySelectorAll('img').forEach(function (x) { x.className = ''; });
          th.className = 'is-on';
        });
        strip.appendChild(th);
      });
      box.appendChild(close); box.appendChild(main); box.appendChild(strip);
      ov.appendChild(box); document.body.appendChild(ov);
      function bye() { ov.remove(); }
      close.addEventListener('click', bye);
      ov.addEventListener('click', function (e) { if (e.target === ov) bye(); });
    });
  }

  /* ---------- ajout au panier -------------------------------------------- */

  function renderATC() {
    var btn = root.querySelector('[data-pmb-atc]');
    var m = totals();
    btn.disabled = !m.complete;
    // 2026-09-25 : plus de prix sur le bouton (Imran). Il est deja affiche dans le palier
    // choisi, juste au-dessus, et repete la il donnait deux fois le meme chiffre.
    btn.innerHTML = m.complete
      ? 'ADD TO CART' // 2026-09-30 : « + » retire (Imran) ; il avait ete ajoute le 2026-09-28
      : 'CHOOSE YOUR ' + CFG.tiers[state.tier].slots + ' DESIGNS';
  }

  // 2026-09-28 : une ligne d'accessoire se coche / decoche d'un clic.
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pmb-addon]');
    if (!a || !root.contains(a)) return;
    a.setAttribute('aria-pressed', a.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
  });

  root.querySelector('[data-pmb-atc]').addEventListener('click', function () {
    var m = totals();
    if (!m.complete) return;
    var btn = this;
    btn.disabled = true; btn.innerHTML = 'Adding&hellip;';
    // 2026-09-28 : chaque article ajoute par le selecteur porte une propriete cachee `_pm_offer`
    // (le « _ » la masque dans le panier et au checkout), pour savoir dans la commande ce qui
    // vient de l'offre de la fiche produit. Voir syncOfferAttr() plus bas.
    var src = OFFER_LABEL[CFG.tiers[state.tier].key] || CFG.tiers[state.tier].title;
    var items = state.slots.map(function (s) {
      return { id: variantFor(s.product).id, quantity: 1, properties: { _pm_offer: src } };
    });
    // 2026-09-28 : accessoires coches au-dessus du bouton, dans le meme ajout que le lot.
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-pmb-addon][aria-pressed="true"]'));
    // Propriete cachee `_pm_addon` (nom court de l'accessoire) : resumee dans l'attribut
    // de panier « Add-ons (product page) », voir syncOfferAttr().
    addons.forEach(function (a) {
      var nm = (a.querySelector('.pmb-add__n') || {}).textContent || 'Add-on';
      items.push({ id: +a.getAttribute('data-vid'), quantity: 1, properties: { _pm_addon: nm.trim() } });
    });
    // 2026-10-09 (panier lent) : le livre offert part dans le meme ajout que les rouleaux s'il
    // n'est pas deja au panier (CFG.gift, mode livre seulement). Avant, pm-free-gifts.js l'ajoutait
    // apres coup : 2e aller-retour et 2e rendu du tiroir, le livre apparaissait ~1,2 s plus tard.
    // pm-free-gifts.js reste le garant (quantite 1, retrait sous le seuil). Si l'ajout avec le livre
    // echoue (livre devenu indisponible), on retente sans lui plutot que de bloquer la cliente.
    var withGift = items;
    if (CFG.gift && CFG.gift.ok && !cartHasGift()) {
      withGift = items.concat([{ id: CFG.gift.vid, quantity: 1 }]);
    }
    function add(list) {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: list })
      });
    }
    add(withGift).then(function (r) {
      if (!r.ok && withGift !== items) return add(items);
      return r;
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      var code = CFG.tiers[state.tier].code;
      // Les remises sont automatiques : rien a appliquer. On garde la branche code
      // au cas ou une offre reviendrait sous cette forme (/discount/<CODE> rattache
      // le code a la session et le panier le reflete immediatement).
      if (code) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; return; }
      // Une fois ajoutes, les accessoires se decochent : un 2e clic n'en rajoute pas en double.
      addons.forEach(function (a) { a.setAttribute('aria-pressed', 'false'); });
      // 2026-10-09 (panier lent) : le tiroir s'ouvre DES que l'ajout est confirme. Avant, il attendait
      // l'ecriture de l'attribut « Offer (product page) » (/cart.js + /cart/update.js, ~0,6 s).
      // Cet attribut est ecrit en arriere-plan par assets/pm-offer-attr.js a chaque rechargement du tiroir.
      if (window.theme && theme.ajaxCart && theme.ajaxCart.update) theme.ajaxCart.update();
      renderATC(); btn.disabled = false;
    }).catch(function () {
      btn.innerHTML = 'Something went wrong — please try again';
      btn.disabled = false;
    });
  });

  /* ---------- marque « offre prise sur la fiche produit » ----------------- */
  // 2026-09-28 (Imran) : un attribut de panier resume ce qui a ete pris via le selecteur.
  // Shopify le recopie sur la commande : il s'affiche dans l'admin et l'app, rubrique
  // « Additional details », sous le nom « Offer (product page) ». Il est recalcule a partir
  // des lignes (propriete _pm_offer), donc il suit si la cliente retire des articles ensuite.
  var OFFER_ATTR = 'Offer (product page)';
  var OFFER_LABEL = { b2g1: 'Buy 3 from Choose Card', single: 'Buy 1 from Product Page' }; // 2026-10-06 : libelles renommes (Imran) ; avant : 'Choose Any 3 Designs' / 'Buy 1 product' ('Buy 1' avant le 2026-10-05). Le resume global vit aussi dans assets/pm-offer-attr.js
  // 2026-10-06 (Imran) : nouveaux libelles. Les paniers ouverts avant le changement portent encore les anciens :
  // on les traduit ici pour que le resume parle toujours la meme langue. Les COMMANDES deja passees gardent
  // leur ancien libelle (historique) — correspondance dans AGENTS.md.
  var OFFER_RENAME = { 'Buy 1': 'Buy 1 from Product Page', 'Buy 1 product': 'Buy 1 from Product Page',
    'Choose Any 3 Designs': 'Buy 3 from Choose Card', 'Buy 1 Collection': 'Buy 1 from Collection Page',
    'Buy 1 Most Loved': 'Buy 1 from Most Loved' };

  var lastOfferAttr = null;

  function offerSummary(cart) {
    var q = {};
    (cart.items || []).forEach(function (it) {
      var v = it.properties && it.properties._pm_offer;
      if (v) { v = OFFER_RENAME[v] || v; q[v] = (q[v] || 0) + it.quantity; }
    });
    var parts = [];
    Object.keys(q).forEach(function (v) {
      if (v === OFFER_LABEL.b2g1) { var lots = Math.floor(q[v] / 3); if (lots) parts.push(v + ' x' + lots); }
      else parts.push(v + ' x' + q[v]);
    });
    return parts.join(' + ');
  }

  // 2026-09-28 : meme principe pour les accessoires pris au-dessus du bouton —
  // attribut « Add-ons (product page) », ex. « Round Cutters x1, Cleaning Brush x1 ».
  var ADDON_ATTR = 'Add-ons (product page)';
  function addonSummary(cart) {
    var q = {}, order = [];
    (cart.items || []).forEach(function (it) {
      var v = it.properties && it.properties._pm_addon;
      if (!v) return;
      if (!(v in q)) { q[v] = 0; order.push(v); }
      q[v] += it.quantity;
    });
    return order.map(function (v) { return v + ' x' + q[v]; }).join(', ');
  }

  function syncOfferAttr() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = offerSummary(cart);
        var have = (cart.attributes && cart.attributes[OFFER_ATTR]) || '';
        var wantAdd = addonSummary(cart);
        var haveAdd = (cart.attributes && cart.attributes[ADDON_ATTR]) || '';
        lastOfferAttr = want;
        if (want === have && wantAdd === haveAdd) return;
        var a = {}; a[OFFER_ATTR] = want; a[ADDON_ATTR] = wantAdd; // vide = Shopify retire l'attribut
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: a })
        });
      }).catch(function () {});
  }

  // Si la cliente retire des articles depuis le tiroir, on remet le resume a jour.
  // 2026-10-09 (panier lent) : ce rafraichissement est retire — assets/pm-offer-attr.js fait le meme
  // calcul sur toutes les pages a chaque rechargement du tiroir. Les deux ecrivaient l'attribut en
  // double (2 lectures de /cart.js + 2 /cart/update.js simultanes). syncOfferAttr() reste disponible.

  // Le livre est-il deja au panier ? Lu sur le dernier panier connu de pm-offer-attr.js (mis a jour a
  // chaque rechargement du tiroir), sinon sur une lecture faite une fois au chargement de la page.
  var bootCart = null;
  if (CFG.gift) fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    .then(function (c) { bootCart = c; }).catch(function () {});
  function cartHasGift() {
    var c = window.pmLastCart || bootCart;
    if (!c || !c.items) return false;
    return c.items.some(function (it) { return it.product_id === CFG.gift.pid; });
  }

  /* ---------- demarrage --------------------------------------------------- */

  setTier(0);
})();
